import React, { Component } from "react";
import { appendScript, removeElement } from '../utils/dom';
import { getPortfolioClient } from '../utils/request';
import { Link } from 'react-router-dom'
import { scrollTo } from "../utils/global";


export class PortfolioSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            attrs :{
                class : "PortfolioSliderScript",
                src : "/js/component/PortfolioSlider.js",
                async : true,
            },
            remove : ".PortfolioSliderScript", // string or array
            Portfolio : [],
			update: false
        };
    }

    componentDidMount() {
        const { attrs, remove } = this.state
        const { ClientId } = this.props
		getPortfolioClient({clientID:ClientId}).then((res)=>{
            res = (Array.isArray(res))? res : [res]
            res = (res[0]===undefined)? [] : res
            this.setState({ Portfolio : res })
            window.g.PortfolioSliderLength = res.length
            appendScript(attrs,remove)
		})
    }
    
    componentDidUpdate(prevProps, prevState, snapshot) {
		if(prevProps.update===true || prevProps.ClientId!==this.props.ClientId){
            this.componentDidMount()
        }
    }

    componentWillUnmount(){
        const { remove } = this.state
        removeElement(remove)
    }

    render() {
        const { main } = this.props
        const { Portfolio } = this.state
        const title = (this.props.portfolioTag!==undefined)? this.props.portfolioTag.title
            : (main.language)? main.language.MENU_PRODUCT : "-"
        if(Portfolio.length<1){ return("") }
        return (
            <div className="Portfolio-member-slider-area section-space--inner--top--40" id="Portfolio">
                <div className="container">
                    {(this.props.portfolioTag!==undefined && this.props.portfolioTag.removeHeader===true)?
                        <div></div>
                    :
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="career-title-area text-center section-space--bottom--50">
                                    <h2 className="title">{ title }</h2>
                                    <p className="subtitle">Professional ethics govern the values of social responsibility that help us deliver our obligations within a coherent social framework.</p>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="Portfolio-slider">
                                <div className="swiper-container Portfolio-slider__container">
                                    <div className="swiper-wrapper Portfolio-slider__wrapper">
                                        {Portfolio.map((p,i) => (
                                            <div key={"mentors-"+i} className="swiper-slide">
                                                <div className="Portfolio-slider__single">
                                                    <div className="image">
                                                        <img src={p.FULL_PATH_IMAGE} className="img-fluid" alt=""/>
                                                    </div>
                                                    <div className="content">
                                                        <div className="identity-wrapper has-border-left single-case-study-project__content">
                                                            <h3 className="name title">
                                                                <Link to={"/Portfolio/"+p.SLUG} target="_self" onClick={(el)=>{ scrollTo(el) }}>
                                                                    {p.TITLE}
                                                                </Link>
                                                            </h3>
                                                            <span className="designation">{p.SUB_TITLE}</span>
                                                        </div>
                                                        <div className="social-links social-links--white-topbar d-inline-block">
                                                            <ul>
                                                                <li>
																	<a href="//facebook.com">
																		<i className="ion-social-facebook"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//twitter.com">
																		<i className="ion-social-twitter"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//linkedin.com">
																		<i className="ion-social-linkedin"></i>
																	</a>
																</li>
                                                                <li>
																	<a href="//skype.com">
																		<i className="ion-social-skype"></i>
																	</a>
																</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="ht-swiper-button-prev ht-swiper-button-prev-14 ht-swiper-button-nav">
									<i className="ion-chevron-left"></i>
								</div>
                                <div className="ht-swiper-button-next ht-swiper-button-next-14 ht-swiper-button-nav">
									<i className="ion-chevron-right"></i>
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PortfolioSlider;